import { render, staticRenderFns } from "./centerInfo.vue?vue&type=template&id=79c224de&scoped=true"
import script from "./centerInfo.vue?vue&type=script&lang=js"
export * from "./centerInfo.vue?vue&type=script&lang=js"
import style0 from "./centerInfo.vue?vue&type=style&index=0&id=79c224de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c224de",
  null
  
)

export default component.exports